export const parseFooterContent = (page) => {
  if (!page?.sections?.length) {
    return null;
  }

  const footerSection = page.sections.find((section) => section.key === 'footer');
  if (!footerSection) {
    return null;
  }

  const fields = footerSection.fields || {};
  const logoMedia =
    footerSection.media?.primary ||
    footerSection.media?.groups?.logo?.[0] ||
    null;
  const logomarkMedia = footerSection.media?.groups?.logomark?.[0] || null;
  const socialMedia = footerSection.media?.groups?.socials || [];

  const socials = socialMedia
    .map((item) => {
      if (!item?.caption) {
        return null;
      }

      try {
        const parsed = JSON.parse(item.caption);
        return {
          name: parsed.name || item.altText || '',
          href: parsed.href || '',
          icon: item.url,
        };
      } catch {
        return null;
      }
    })
    .filter(Boolean);

  const columns = page.sections
    .filter((section) => section.key.startsWith('footer-column-'))
    .map((section) => {
      const sectionFields = section.fields || {};
      const links = [];

      for (let index = 1; index <= 20; index += 1) {
        const label = sectionFields[`link-${index}-label`];
        if (!label) {
          break;
        }

        links.push({
          label,
          to: sectionFields[`link-${index}-url`] || '#',
        });
      }

      return {
        id: section.key.replace('footer-column-', ''),
        title: sectionFields.title || '',
        links,
      };
    });

  return {
    logo: logoMedia
      ? {
          url: logoMedia.url,
          alt: logoMedia.altText || 'VBS Invest',
        }
      : null,
    logomark: logomarkMedia
      ? {
          url: logomarkMedia.url,
          alt: logomarkMedia.altText || '',
        }
      : null,
    about: fields.about || '',
    disclaimer: fields.disclaimer || '',
    copyright: fields.copyright || 'VBS Invest. All rights reserved.',
    socials,
    columns,
  };
};
